/* Progressive enhancements for the reference product layout. */
(() => {
  if (window.gommadotReferenceReady) return;
  window.gommadotReferenceReady = true;
  const feedback = (root, text) => {
    const region = root.querySelector('[data-pdp-feedback]');
    if (region) region.textContent = text;
  };
  document.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-pdp-copy], [data-pdp-share]');
    if (!control) return;
    const root = control.closest('[data-reference-product]');
    try {
      if (control.matches('[data-pdp-copy]')) {
        const ean = root.querySelector('[data-product-barcode]')?.textContent.trim();
        if (!ean) return;
        await navigator.clipboard.writeText(ean);
        feedback(root, root.dataset.eanCopied);
      } else {
        const data = { title: control.dataset.shareTitle, url: control.dataset.shareUrl };
        if (navigator.share) await navigator.share(data);
        else { await navigator.clipboard.writeText(data.url); feedback(root, root.dataset.linkCopied); }
      }
    } catch (error) {
      if (error.name !== 'AbortError') feedback(root, root.dataset.shareFallback);
    }
  });
  document.addEventListener('submit', async (event) => {
    const button = event.submitter;
    if (!button?.matches('[data-buy-now]')) return;
    event.preventDefault();
    const form = event.target;
    const root = form.closest('[data-reference-product]');
    if (!form.reportValidity() || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const data = new FormData(form);
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || root.dataset.addError);
      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    } catch (error) {
      feedback(root, error.message || root.dataset.retry);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
